
/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */

import { Button, Grid } from '@mui/material'
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDTypography from 'components/MDTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React, { useEffect, useState } from 'react'
import TransactionTable from './Component/Table'
import { useDispatch, useSelector } from 'react-redux'
import { getAllTransaction } from 'Redux/actions/transaction'
import AddModal from './Component/addModal'
import './style.css'

const Transaction = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [edit, setEdit] = useState(false);
    let transactions = useSelector(state => state?.transaction);
    let loader=transactions?.loading;
    transactions = transactions?.transactions;
    // console.log(transactions)
    const [formdata, setFormData] = useState({
        name: "",
        amount: "",
        date: new Date(),
        type: "",
    });
    const handleDebitOpen = () => {

        setFormData({ ...formdata, name: "", amount: "", date: new Date(), type: "debit" });
        edit && setEdit(false);
        setOpen(true);
    }
    const handleCreditOpen = () => {
        setFormData({ ...formdata, name: "", amount: "", date: new Date(), type: "credit" })
        edit && setEdit(false);
        setOpen(true);
    }
    useEffect(() => {
        dispatch(getAllTransaction());
    }, [dispatch])
    return (
        <>
            <DashboardLayout>
                <DashboardNavbar />
                {
                    loader ? <div className="loader"></div> :
                    <Grid container >
                    <Grid xs={12} md={6} lg={6} >
                        <MDBox sx={{ width: "500px", marginRight: "10px" }} >
                            <MDBox sx={{ display: "flex", justifyContent: "space-between", marginLeft: "8px", marginRight: "8px", pt: "8px" }}>
                                <MDTypography fontWeight="medium">DEBIT</MDTypography>
                                <MDButton variant="contained" color="info" size="small" sx={{ float: "right", margin: "4px" }} >
                                    <MDTypography onClick={handleDebitOpen} variant="button" fontWeight="bold" color="white">ADD</MDTypography>
                                    <AddModal open={open} setOpen={setOpen} formData={formdata} setFormData={setFormData} edit={edit} setEdit={setEdit} />

                                </MDButton>
                            </MDBox>
                            <MDBox  sx={{ height: "400px",overflowX:"scroll",ml: "8px", mt: "8px" }}>
                                <TransactionTable transactions={transactions?.debit} formdata={formdata} setFormData={setFormData} type={"debit"} setOpen={setOpen} edit={edit} setEdit={setEdit} />
                            </MDBox>
                        </MDBox>
                            <MDBox sx={{ ml: "8px", mt: "8px" }}>
                                Total:<MDTypography variant="h4" className="transaction-cd"  fontWeight="bold" color="white"> {transactions?.totalDebit}</MDTypography>
                            </MDBox>
                    </Grid>
                    <Grid xs={12} md={6} lg={6} >
                        <MDBox sx={{  width: "500px", marginRight: "10px" }} >
                            <MDBox sx={{ display: "flex", justifyContent: "space-between", marginLeft: "8px", marginRight: "8px", pt: "8px" }}>
                                <MDTypography fontWeight="medium" >CREDIT</MDTypography>
                                <MDButton variant="contained" color="info" size="small" sx={{ float: "right", margin: "4px" }} >
                                    <MDTypography onClick={handleCreditOpen} variant="button" fontWeight="bold" color="white">ADD</MDTypography>
                                    <AddModal open={open} setOpen={setOpen} formData={formdata} setFormData={setFormData} edit={edit} setEdit={setEdit} />
                                </MDButton>
                            </MDBox>
                            <MDBox sx={{height: "400px",overflowX:"scroll", ml: "8px", mt: "8px" }}>
                           <TransactionTable transactions={transactions?.credit} formData={formdata} setFormData={setFormData} type={"debit"} setOpen={setOpen} edit={edit} setEdit={setEdit} />
                            </MDBox>
                        </MDBox>
                            <MDBox sx={{ ml: "8px", mt: "8px" }}>
                            Total:<MDTypography variant="h4" className="transaction-cd"  fontWeight="bold" color="white" > {transactions?.totalCredit}</MDTypography>
                            </MDBox>
                    </Grid>
                </Grid>
                }

            </DashboardLayout>
        </>
    )
}

export default Transaction
